import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Layout/Header";
import EndUserSidebar from "./Layout/Sidebar";
import Footer from "../common/Layout/Footer";
import TitleHeader from "../common/TitleHeader";
import HouseIcon from "apollo-react-icons/House";
import MedicalCard from "apollo-react-icons/MedicalCard";
import FileAccountPlan from "apollo-react-icons/FileAccountPlan";
import Container from "apollo-react/components/Container";
import ChatSupport from "../common/chatbot/ChatSupport";
import { getCurrentUser } from "./services/authService";
import CommonBreadcrumbs, { getPageName } from "../common/CommonBreadcrumbs";


const Layout = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const [size, setSize] = useState([0, 0]);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const iconStyles = { fontSize: "36px", color: "#4D4D4D" };
  const pages = [
    { name: "home", icon: <HouseIcon style={{ ...iconStyles }} /> },
    { name: "users", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "endusers", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "roles", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "categories", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "logs", icon: <FileAccountPlan style={{ ...iconStyles }} /> },
  ];

  useEffect(() => {
    const [width] = size;
    if (width < 850 && width !== 0) setIsSidebarCollapsed(true);
  }, [size]);

  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    const savedSidebarState = localStorage.getItem("isSidebarCollapsed") === "true";
    setIsSidebarCollapsed(savedSidebarState);
  }, []);

  const handleSidebarToggle = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
    if (collapsed) {
      localStorage.setItem("isSidebarCollapsed", true);
    } else {
      localStorage.removeItem("isSidebarCollapsed");
    }
  };

  const pageName = getPageName("end-user", location);

  return (
    <div>
      <Container
        className="main-container"
        style={{
          marginLeft: isSidebarCollapsed ? "64px" : "320px",
          width: isSidebarCollapsed ? "100%" : "75%",
        }}
      >
        <Header />
        
        <EndUserSidebar
          isSidebarCollapsed={isSidebarCollapsed}
          setIsSidebarCollapsed={handleSidebarToggle}
        />

        <main className="main-content">
          <CommonBreadcrumbs
            source="end-user"
            pathnames={pathnames}
            location={location}
          />

          <TitleHeader
            title={pageName}
            icon={pages.find((page) => page.name === pageName)?.icon}
          />

          <Outlet />
        </main>

        <Footer />
      </Container>
      <ChatSupport getCurrentUser={getCurrentUser} />
    </div>
  );
};

export default Layout;
